
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 9.167h-5v-5a.833.833 0 10-1.666 0v5h-5a.833.833 0 100 1.666h5v5a.833.833 0 101.666 0v-5h5a.833.833 0 100-1.666z"}})])
          )
        }
      }
    